/** FAQ copy from Lovable template — structured for accordion rendering. */
export const FAQ_SECTIONS = [
  {
    title: "General",
    items: [
      {
        q: "Who are we?",
        a: [
          "We are an educational trading and investing service focused on empowering members to become better traders and investors. We are not interested in low cap \"pumping\" Alt-Coins or intra-day day trading. If you are looking for a Discord-like channel with random trade ideas authored by amateurs, then this service is not for you.",
          "We feature analysts with over 125 years of combined experience trading and investing in all traditional markets, as well as the crypto landscape. Unlike fly-by-night \"paid groups\", our mission is to provide an in-depth look into how our traders view and approach the markets, how they trade them, to share their psychology in near real time, and to help you achieve your own personal best.",
        ],
      },
      {
        q: "How many analysts are there?",
        a: [
          "We feature five different financial analysts with over 125 years of collective trading and investing experience. They all bring their own unique style to Bitcoin Live, which is the beauty of the platform, making it all-encompassing. There is something to learn from each trader and from there you can ultimately decide whose style aligns with yours and follow them at a deeper level.",
          "We also have multiple featured contributors on a rotating basis to provide additional perspectives for members. You can expect a couple of posts from outside featured contributors throughout the course of the month. These contributors are highly vetted by the core analyst team to ensure their content meets the quality standard of Bitcoin Live.",
        ],
      },
      {
        q: "How often is content released?",
        a: [
          "Content is released at the discretion of each analyst. Each analyst operates independently — there is no \"Bitcoin Live\" specific analysis or consensus. Each analyst will release content on a different timeframe, depending on availability and schedule. In general, each analyst will release one piece of content per week, with some analysts providing two per week.",
        ],
      },
    ],
  },
  {
    title: "Membership Opportunities",
    items: [
      {
        q: "What membership plans do you offer?",
        a: [
          "We offer three different options for membership plans — monthly, quarterly, and yearly. The membership tiers are designed to reward members who choose to stay longer with a steeper discount. A majority of our members are longer term and are committed to becoming better traders and investors.",
        ],
      },
      {
        q: "What payment options are accepted?",
        a: [
          "We accept all major forms of credit cards via our trusted payment processor, Stripe. If you are interested in paying with crypto instead of a traditional bank, we securely accept Bitcoin via the BTCPay Server.",
        ],
      },
      {
        q: "Are there any discounts available?",
        a: [
          "The checkout form features a coupon field. We have only two sales (at most) throughout the year. Keep an eye out for these opportunities and feel free to enter rebate codes you come across on the checkout form to take advantage.",
        ],
      },
    ],
  },
  {
    title: "Site Areas",
    items: [
      {
        q: "Public Blog",
        a: [
          "About once per month, we take a premium member content post and make it available to the public. These posts are featured in the public blog area, accessible to all. If you are not a member, you can get a free glimpse into the premium content that members have access to.",
        ],
      },
      {
        q: "Member Content",
        a: [
          "All the premium long-form posts, videos, and reports from the analysts and featured contributors are located here. The main page is a feed of all the posts shared, with the most recent at the top.",
          "You can see which analyst shared the post, the title, and various tags related to the post. Individual posts can be in blog format containing text and images, or traders will share a video discussion of charts they are following and an in-depth discussion of what they're thinking.",
          "There is an interactive comments section on every post where members can post questions for the analyst and receive valuable insight. This is your opportunity to communicate 1-on-1 with the analysts. Feel free to ask questions related to the individual post, general questions, or just provide positive feedback. We pride ourselves on the personal touch at Bitcoin Live, and analysts are strongly encouraged to respond to all members in the comments section on their posts.",
          "The search bar found in the upper header area of the site allows members to access content posts based on specific criteria they are interested in. The search is designed to locate reports that contain the words you search for in their titles or within the tags attached to each post.",
        ],
      },
      {
        q: "Alerts",
        a: [
          "This area is designed for quick-hitting, bite-size pieces of information similar in style to Twitter. When analysts want to get time-sensitive information out, or share something that is insufficient in size for a post, they will issue an alert.",
          "Alerts come in either an Informational or Trade alert format. Informational alerts contain general market commentary or notes. Trade alerts are actionable setups that an analyst is engaging in himself. These alerts contain entry, target, and stop loss fields. They are marked as long or short and the ticker of the coin being traded is shown.",
          "There is also a thread functionality for alerts. Analysts will provide updates to an original alert as new information becomes available and narratives progress. Be aware of the \"Track Trade\" button that you can select to monitor an alert more closely. When this button is engaged you will receive notifications regarding the alert, and it will be featured at the top of your alerts feed.",
          "Drill down into alerts by categories: open trade, closed trade, informational, tracking. Further filter by analyst with these criteria as well.",
        ],
      },
      {
        q: "Analysts",
        a: [
          "This area is for organizational purposes relating to each individual analyst and featured contributor. All the content from an analyst is housed on their profile. You can easily scan just the alerts, posts, or educational pieces by each analyst here.",
        ],
      },
      {
        q: "Education",
        a: [
          "The major focus of this platform is trading and market commentary, but we do offer an educational section as well. This area features timeless posts, anecdotes, and other material that the team of analysts has compiled with their collective wisdom of trading careers spanning over 125 years combined.",
          "You can filter by the categories: crypto insights, psychology, risk management, strategy, and technical analysis. You also have the option to drill down into these categories by individual analyst. There is something here for everyone, and any level of trader can pick up nuances to add to their trading repertoire. We especially suggest this section for those just starting out in crypto trading and investing, as it is a place to build your foundation.",
        ],
      },
    ],
  },
  {
    title: "Your Profile",
    items: [
      {
        q: "Personal",
        a: [
          "This is your control panel. You can change basic items like your display name, email address, phone number, and password here. There is also a Favorites section so you can keep important pieces of content saved, allowing you quick access to this content whenever you like. All posts and alerts can be favorited via the star button on the content.",
        ],
      },
      {
        q: "Custom Alerts",
        a: [
          "You have ultimate customization with how you want to be notified when there is new Bitcoin Live content via the Notifications tab. We offer email, platform, and browser notifications for alerts or posts — filtered down by analyst. You can also choose to be notified for all alerts you are tracking and when an analyst replies to your comment under his post. This level of customization gives you the flexibility to tailor your alerts based on the content you want to see.",
        ],
      },
      {
        q: "Billing",
        a: [
          "Your Billing tab gives you many different options to control and keep track of your membership. Keep track of all your past payment history and see when your next renewal date is scheduled. You have the option to toggle between credit card and Bitcoin payments. You can add a different credit card whenever necessary.",
          "If you are paying via Bitcoin, you have the option to renew your subscription with Bitcoin prior to your renewal date to avoid losing access. If you are enjoying the service, you have the easy ability to upgrade to the discounted plans whenever you like. Keep an eye out for member-only flash sales that we offer in your billing area to save and renew ahead of time.",
          "If you wish to cancel your membership, simply send us a note via the support option at any time.",
        ],
      },
      {
        q: "Dark Mode",
        a: [
          "We offer both a light and dark mode interface for your convenience. The default setting is Light Mode.",
        ],
      },
    ],
  },
];

export const FAQ_TERMS_LINKS = [
  { label: "Terms and Conditions", to: "/terms&conditions" },
  { label: "Privacy Policy", to: "/policy" },
];
